import React from 'react';

import { useAutoNavigate } from '@betterment/js-runtime';
import { Box, CenteredLayout, HStack, IconButton, VStack, WorkflowHeader } from '@betterment/samba-react';
import { useNavigate } from 'react-router-dom';

import { useDistributionFlow } from './hooks';

import { urlBuilder } from '../Shared/urlBuilder';

interface Props {
  children: React.ReactNode;
  gap?: string;
}

const FlowLayout: React.FC<Props> = ({ children, gap = 'space.400' }) => {
  const navigateRelative = useNavigate();
  const navigateAbsolute = useAutoNavigate();
  const { prevStep } = useDistributionFlow();

  const handleBack = () => {
    if (prevStep) void navigateRelative(`../${prevStep}`, { relative: 'path' });
  };

  const handleClose = async () => {
    await navigateAbsolute(urlBuilder.appHome.absolute());
  };

  return (
    <Box css={{ background: 'background.surface', width: '100%', minHeight: '100vh' }}>
      <HStack
        css={{
          bg: 'background.surface',
          borderBottomWidth: 'thin',
          borderBottom: 'solid',
          borderBottomColor: 'border.weak',
          position: 'sticky',
          top: '0',
          width: '100%',
          justifyContent: 'center',
          paddingX: { base: 'space.0', md: 'space.400' },
        }}
      >
        <WorkflowHeader css={{ width: '100%' }}>
          <WorkflowHeader.Leading>
            {prevStep && (
              <IconButton label="Back" name="LeftArrow" spacing="default" onClick={() => void handleBack()} />
            )}
          </WorkflowHeader.Leading>
          <WorkflowHeader.Title>401(k) distribution</WorkflowHeader.Title>
          <WorkflowHeader.Trailing>
            <IconButton label="Close" name="X" spacing="default" onClick={() => void handleClose()} />
          </WorkflowHeader.Trailing>
        </WorkflowHeader>
      </HStack>

      <CenteredLayout size="full" css={{ mt: 'space.300', md: { mt: 'space.800' } }}>
        <VStack
          css={{
            gap,
            maxWidth: '584px',
            width: '100%',
            mx: 'auto',
            px: 'space.300',
            pb: 'space.500',
          }}
        >
          {children}
        </VStack>
      </CenteredLayout>
    </Box>
  );
};

export { FlowLayout };
